import type { Infer } from 'superstruct';
import { number, object, string } from 'superstruct';

import { stringDate } from '@adflow/shared/util-superstruct';

export const ViewGMBAccountDto = object({
	id: number(),
	googleId: string(),
	name: string(),

	syncedAt: stringDate(),
	createdAt: stringDate(),
	updatedAt: stringDate(),
});

export type ViewGMBAccountDto = Infer<typeof ViewGMBAccountDto>;
